import React from 'react';

interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
}

const ErrorIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-error dark:text-dark-error" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
    </svg>
);


const ErrorModal: React.FC<ErrorModalProps> = ({ isOpen, onClose, title, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-scrim/30 dark:bg-scrim/50 z-50 flex items-center justify-center p-4 animate-fade-in" onClick={onClose} aria-modal="true" role="alertdialog">
      <div className="relative bg-surface-container-high dark:bg-dark-surface-container-high rounded-3xl shadow-2xl w-full max-w-sm m-4 transform animate-scale-in text-center p-6" onClick={e => e.stopPropagation()}>
        <div className="flex flex-col items-center">
            <ErrorIcon />
            <h2 className="text-xl font-medium text-on-surface dark:text-dark-on-surface mt-4">{title}</h2>
            <p className="mt-2 text-sm text-on-surface-variant dark:text-dark-on-surface-variant">
                {message}
            </p>
            <button
                onClick={onClose}
                className="mt-6 w-full bg-primary dark:bg-dark-primary hover:shadow-lg text-on-primary dark:text-dark-on-primary font-bold py-2 px-4 rounded-full transition-shadow focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary dark:focus:ring-offset-dark-surface-container-high"
            >
                Entendido
            </button>
        </div>
      </div>
      <style>{`
        @keyframes fade-in { from { opacity: 0; } to { opacity: 1; } }
        .animate-fade-in { animation: fade-in 0.3s ease-out forwards; }
        @keyframes scale-in { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        .animate-scale-in { animation: scale-in 0.3s ease-out forwards; }
      `}</style>
    </div>
  );
};

export default ErrorModal;
